import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

function Footer() {
  return (
      <Container className="bg-light text-white mt-5 p-0" fluid>
        <Row className="d-flex align-items-center">
          <Col className="text-center text-dark">
            <small>&copy; {new Date().getFullYear()} CIVILIO Information Systems s.l.</small>
          </Col>
        </Row>
      </Container>
  )
}

export default Footer